import { useCallback, useEffect } from 'react';

import { useDebouncedRemoteSearch } from '@/components/shared/use-debounced-remote-search';
import { usePagesStore } from '@/stores/pages-store';
import type { Page } from '@/types/page';
import { fetchTreePages } from './page-utils';

interface UseTreeSearchResultsReturn {
  navigationTree: Page[];
  nonNavigationTree: Page[];
  isLoading: boolean;
  isSearching: boolean;
}

export function useTreeSearchResults(searchQuery: string): UseTreeSearchResultsReturn {
  const searchTreePages = useCallback((query: string) => fetchTreePages(query), []);
  const { data, isLoading, isSearching } = useDebouncedRemoteSearch({
    query: searchQuery,
    search: searchTreePages,
  });

  const setSearchResults = usePagesStore((state) => state.setSearchResults);
  const searchResults = usePagesStore((state) => state.searchResults);

  useEffect(() => {
    setSearchResults({
      mainNavigationTree: data?.navigation ?? [],
      nonNavigationTree: data?.nonNavigation ?? [],
    });
  }, [data, setSearchResults]);

  return {
    navigationTree: searchResults?.mainNavigationTree ?? [],
    nonNavigationTree: searchResults?.nonNavigationTree ?? [],
    isLoading,
    isSearching,
  };
}
